'use client';
import { Flex } from '@osmosis/tailwind-ui/components/Box';

import React, { useState } from 'react';

import AuthLogo from '../../../components/auth/AuthLogo';
import AuthHeader from '../../../components/auth/AuthHeader';
import AuthForm from '../auth/AuthForm';
import AuthMigrateLoginForm from '../auth/AuthMigrateLoginForm';
import AuthContactUs from '../auth/AuthContactUs';

type Props = {
  showSignUp?: boolean;
  showContactUs?: boolean;
  inviteCode?: string;
};
/**
 * AuthMigrateLoginPage.
 */
const AuthMigrateLoginPage = ({
  showSignUp = true,
  showContactUs = true,
  inviteCode = undefined,
}: Props) => {
  const [userEmail, setUserEmail] = useState('');
  const [showEmailForm, setShowEmailForm] = useState(true);
  const [showPassNotice, setShowPassNotice] = useState(false);
  return (
    <Flex className="flex-col items-center justify-center">
      <AuthLogo />
      <AuthHeader />
      {showEmailForm ? (
        <AuthMigrateLoginForm
          email={userEmail}
          setShowPassNotice={setShowPassNotice}
          setUserEmail={setUserEmail}
          setShowEmailForm={setShowEmailForm}
          showSignUp={showSignUp}
          inviteCode={inviteCode}
        />
      ) : (
        <AuthForm showPassNotice={showPassNotice} email={userEmail} />
      )}
      {showContactUs && <AuthContactUs />}
    </Flex>
  );
};

export default AuthMigrateLoginPage;
